
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import Spinner from '@/components/common/Spinner.vue';
import moment from "moment";
import get from 'lodash/get';

@Component({
	components: {
		Spinner,
	},
})
export default class DataTable extends Vue {
	@Prop({ default: () => [] }) readonly columns!: any[];
	@Prop({ required: true, default: [] }) readonly data!: any[];
	@Prop({ default: () => [] }) readonly selectedRows!: number[];
	@Prop({ default: () => [] }) readonly selectedRowsRecords!: any[];
	@Prop({ default: false }) readonly hasActions!: boolean;
	@Prop({ default: true }) readonly showSelect!: boolean;
	@Prop({ default: false }) readonly loading!: boolean;
	@Prop({ default: null }) readonly sort_by!: string;
	@Prop({ default: null }) readonly sort_direction!: string;
	@Prop({ type: Function, default: undefined })  getBodyRowClasses?: Function;

	get areAllSelected(): boolean {
		return (
			this.data.length &&
			this.data.every((row) => this.selectedRows.includes(row.id))
		);
	}

	@Emit('update:selectedRows')
	updateSelectedRows(selectedRows: number[]) {
		return selectedRows;
	}
	@Emit('update:selectedRowRecords')
	updateSelectedRowRecords(selectedRowRecords: any[]) {
		return selectedRowRecords;
	}
	toggleSelection(rowId: number, row: any) {
		let newSelectedRows = [];
		let newSelectedRowRecords = [];

		const isExist = this.selectedRows.includes(rowId);

	if(isExist){
		newSelectedRows= this.selectedRows.filter((id) => id !== rowId) // remove the id
		newSelectedRowRecords = this.selectedRowsRecords.filter(row => row.id !== rowId)
	}else {
		newSelectedRows=[...this.selectedRows, rowId]; // add the id
		newSelectedRowRecords = [...this.selectedRowsRecords, row]

	}

		this.updateSelectedRowRecords(newSelectedRowRecords);
		this.updateSelectedRows(newSelectedRows);
	}
	handleProjectClick(row) {
		this.$emit('projectClick',row);
  }
	selectAllRows(event: Event) {
		const target = event.target as HTMLInputElement;
		const newSelectedRows = target.checked
			? this.data.map((row) => row.id)
			: [];
		this.updateSelectedRowRecords(this.data);
		this.updateSelectedRows(newSelectedRows);
	}
	getRowValue(row: any, field: string) {
		return get(row, field);
	}
	getDateValue(field: string){
if (!field) return '';
  return moment(field).format('YYYY-MM-DD');
	}
	sortColumn(field: string) {
		if (this.sort_direction === 'desc') {
			this.$emit('sort', {});
		} else {
			const newOrder: string =
				this.sort_by === field && this.sort_direction === 'asc'
					? 'desc'
					: 'asc';
			this.$emit('sort', { sortBy: field, sortDirection: newOrder });
		}
	}
  // This JavaScript code adds the 'safari' class to the body element when the browser is Safari.
  isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  if (isSafari) {
    document.body.classList.add('safari');
  }
}
